import { useTranslation } from 'react-i18next';

import { Anchor } from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import { PharmacyChangeModal } from './PharmacyChangeModal';

type PharmacyChangeProps = {
    drxId: string;
};

export const PharmacyChangeLink = ({ drxId }: PharmacyChangeProps) => {
    const [opened, { toggle }] = useDisclosure();
    const { t } = useTranslation();

    return (
        <>
            <Anchor
                textAlign="center"
                textDecoration="underline"
                onClick={toggle}
            >
                {t('providerOffers.pharmacyChange.link')}
            </Anchor>

            <PharmacyChangeModal
                drxId={drxId}
                isOpen={opened}
                toggle={toggle}
            />
        </>
    );
};
